import { setRecoil } from 'recoil-nexus';

import myScribeAiState from 'components/practice/charts/ClinicalNote/MyScribeAI/state';

const updateSpecialty = (data) => {
  const { specialty, intelligence_chat_id } = data;
  if (intelligence_chat_id)
    setRecoil(myScribeAiState.intelligenceChatIdState, intelligence_chat_id);

  if (specialty) setRecoil(myScribeAiState.specialtyState, specialty);
};

export default updateSpecialty;
